import { render, staticRenderFns } from "./MainInterface.vue?vue&type=template&id=0cda4b33&scoped=true&"
import script from "./MainInterface.vue?vue&type=script&lang=js&"
export * from "./MainInterface.vue?vue&type=script&lang=js&"
import style0 from "./MainInterface.vue?vue&type=style&index=0&id=0cda4b33&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cda4b33",
  null
  
)

export default component.exports